import { render, staticRenderFns } from "./ShoppingCartSettings.vue?vue&type=template&id=793f1219"
import script from "./ShoppingCartSettings.vue?vue&type=script&lang=js"
export * from "./ShoppingCartSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports